export enum ActiveTabEnum {
  STEP_METRICS = 'stepMetrics',
  RELATED_WINDOWS = 'relatedWindows',
  USER_ACTIVITIES = 'userActivities',
  TASK_ANALYSIS = 'taskAnalysis',
}
